import React, { useState, useEffect } from 'react';
import './../../css/table.css';
import axios from 'axios';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import InputCustom from '../Auth/InputCustom';
import styles from '../Auth/input.module.css';
import TextAreaCustom from '../Auth/TextAreaCustom';

const MySwal = withReactContent(Swal);

const NewStudyOpportunity = () => {
  const [countries, setCountries] = useState([]);
  const [majors, setMajors] = useState([]);

  useEffect(() => {
    getMajors();
    getCountries();
  }, []);

  const getMajors = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/panel/show-all-major`)
      .then((res) => {
        console.log('majors', res);
        setMajors(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCountries = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/show-country-filter`)
      .then((res) => {
        console.log(res);
        setCountries(res.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const initialValues = {
    title: '',
    title_fa: '',
    city: '',
    country: '',
    apply_link: '',
    responsibility: '',
    document: '',
    deadline: '',
    grade: '',
    major: '',
    university: '',
  };
  const validationSchema = yup.object({
    title: yup.string().required('وارد کردن عنوان الزامیست'),
    title_fa: yup.string().required('وارد کردن عنوان فارسی الزامیست'),
    city: yup.string().required('وارد کردن شهر الزامیست'),
    country: yup.string().required('وارد کردن کشور الزامیست'),
    major: yup.string().required('وارد کردن رشته الزامیست'),
    apply_link: yup.string().required('وارد کردن لینک اپلای الزامیست'),
    responsibility: yup.string().required('وارد کردن مسئولیت الزامیست'),
    document: yup.string().required('وارد کردن مدارک الزامیست'),
    grade: yup.string().required('وارد کردن مقطع الزامیست'),
    deadline: yup.string().required('وارد کردن ددلاین الزامیست'),
    university: yup.string().required('وارد کردن دانشگاه الزامیست'),
  });

  const onSubmit = (state) => {
    axios
      .post('https://arianaapp.arianaapply.com/panel/create-study-opportunity', {
        title: state.title,
        title_fa: state.title_fa,
        city: state.city,
        country: state.country,
        apply_link: state.apply_link,
        responsibility: state.responsibility,
        document: state.document,
        deadline: state.deadline,
        major: state.major,
        grade: state.grade,
        university: state.university,
      })
      .then((response) => {
        console.log(response);
        MySwal.fire({
          title: 'با موفقیت ثبت شد',
          icon: 'success',
        }).then((result) => {
          if (result) {
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <div className='index'>
      {majors ? (
        <form onSubmit={formik.handleSubmit}>
          <InputCustom
            name='title'
            type='text'
            label='عنوان ...'
            formikHandler={formik.getFieldProps('title')}
            formikErrors={formik.errors.title && formik.touched.title}
            formikErrorsName={formik.errors.title}
          />
          <InputCustom
            name='title_fa'
            type='text'
            label='عنوان فارسی ...'
            formikHandler={formik.getFieldProps('title_fa')}
            formikErrors={formik.errors.title_fa && formik.touched.title_fa}
            formikErrorsName={formik.errors.title_fa}
          />
          <InputCustom
            name='city'
            type='text'
            label='َشهر...'
            formikHandler={formik.getFieldProps('city')}
            formikErrors={formik.errors.city && formik.touched.city}
            formikErrorsName={formik.errors.city}
          />
          <div className={styles.inputWrap}>
            <label className={styles.label}>کشور...</label>
            <select
              name='country'
              className={
                formik.errors.country && formik.touched.country
                  ? styles.inputError
                  : styles.input
              }
              {...formik.getFieldProps('country')}>
              <option value=''>انتخاب کنید...</option>
              {countries?.map((c) => (
                <option key={c.country} value={c.country}>
                  {c.country}
                </option>
              ))}
            </select>
            {formik.errors.country && formik.touched.country && (
              <p className={styles.errorText}>{formik.errors.country}</p>
            )}
          </div>
          <InputCustom
            name='university'
            type='text'
            label='دانشگاه...'
            formikHandler={formik.getFieldProps('university')}
            formikErrors={formik.errors.university && formik.touched.university}
            formikErrorsName={formik.errors.university}
          />
          <div className={styles.inputWrap}>
            <label className={styles.label}>رشته تحصیلی...</label>
            <select
              name='major'
              className={
                formik.errors.major && formik.touched.major
                  ? styles.inputError
                  : styles.input
              }
              {...formik.getFieldProps('major')}>
              <option value=''>انتخاب کنید...</option>
              {majors?.map((c) => (
                <option key={c.major_fa} value={c.major_fa}>
                  {c.major_fa}
                </option>
              ))}
            </select>
            {formik.errors.major && formik.touched.major && (
              <p className={styles.errorText}>{formik.errors.major}</p>
            )}
          </div>
          <InputCustom
            name='grade'
            type='text'
            label='مدرک تحصیلی...'
            formikHandler={formik.getFieldProps('grade')}
            formikErrors={formik.errors.grade && formik.touched.grade}
            formikErrorsName={formik.errors.grade}
          />
          <InputCustom
            name='apply_link'
            type='text'
            label='لینک اپلای...'
            formikHandler={formik.getFieldProps('apply_link')}
            formikErrors={formik.errors.apply_link && formik.touched.apply_link}
            formikErrorsName={formik.errors.apply_link}
          />
          <InputCustom
            name='deadline'
            type='date'
            label='ددلاین..'
            formikHandler={formik.getFieldProps('deadline')}
            formikErrors={formik.errors.deadline && formik.touched.deadline}
            formikErrorsName={formik.errors.deadline}
          />

          <TextAreaCustom
            name='responsibility'
            type='text'
            label='مسئولیت ها..'
            formikHandler={formik.getFieldProps('responsibility')}
            formikErrors={
              formik.errors.responsibility && formik.touched.responsibility
            }
            formikErrorsName={formik.errors.responsibility}
          />

          <TextAreaCustom
            name='document'
            type='text'
            label='مدارک..'
            formikHandler={formik.getFieldProps('document')}
            formikErrors={formik.errors.document && formik.touched.document}
            formikErrorsName={formik.errors.document}
          />

          <div className='inputBox'>
            <button
              type='submit'
              className={!formik.isValid ? 'btn-gray' : 'btn-success'}
              disabled={!formik.isValid}>
              ثبت
            </button>
          </div>
        </form>
      ) : (
        <Spinner animation='border' variant='primary' />
      )}
    </div>
  );
};
export default NewStudyOpportunity;
